import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


/** Left column, under the images (desktop): Certificate of Authenticity, Provenance,
 * Exhibited, Literature, Write-up, each collapsible. */
export default function LotCatalogueFields({
  ExhibitedFunction,
  ProvinanceFunction,
  WriteupFunction,
  coa,
  exhibited,
  exhibitedShow,
  formatText,
  isDesktop,
  isWidraw,
  literature,
  literatureFunction,
  literatureShow,
  provenance,
  provinanceShow,
  write_up,
  writeupShow,
}) {
  return (
    <>
      {/* Inalis ang d-none d-lg-block para lumabas sa lahat ng screen size */}
      {/* Siguraduhin na ang mga states at isDesktop ay naka-define sa itaas */}
      <div style={{ marginTop: "40px" }}>
        {isWidraw !== 1 && (
          <div>
            <div
              style={{
                borderBottom: "1px solid #f0f0f0",
                marginBottom: "30px",
                opacity: 1,
              }}
            />

            {isDesktop ? (
              /* --- DESKTOP VIEW: ORIGINAL ACCORDION UI --- */
              <div>
                {[
                  {
                    label: "CERTIFICATE OF AUTHENTICITY",
                    val: coa,
                    show: provinanceShow,
                    func: ProvinanceFunction,
                  },
                  {
                    label: "PROVENANCE",
                    val: provenance,
                    show: provinanceShow,
                    func: ProvinanceFunction,
                  },
                  {
                    label: "EXHIBITED",
                    val: exhibited,
                    show: exhibitedShow,
                    func: ExhibitedFunction,
                  },
                  {
                    label: "LITERATURE",
                    val: literature,
                    show: literatureShow,
                    func: literatureFunction,
                  },
                  {
                    label: "WRITE-UP",
                    val: write_up,
                    show: writeupShow,
                    func: WriteupFunction,
                  },
                ].map(
                  (item, idx) =>
                    item.val && (
                      <div
                        key={idx}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          padding: "18px 0",
                        }}
                      >
                        <div
                          onClick={item.func}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              fontWeight: 800,
                              letterSpacing: "1px",
                            }}
                          >
                            {item.label}
                          </h4>
                          {item.show ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </div>

                        {!item.show && (
                          <div
                            style={{
                              marginTop: "15px",
                              fontSize: "1.05rem",
                              lineHeight: "1.8",
                              color: "#444",
                            }}
                          >
                            <p
                              dangerouslySetInnerHTML={{
                                __html: formatText(item.val),
                              }}
                            ></p>
                          </div>
                        )}
                      </div>
                    )
                )}
              </div>
            ) : (
              /* --- MOBILE VIEW: SIMPLE TEXT LINK ONLY --- */
              ""
            )}
          </div>
        )}
      </div>
    </>
  );
}
